
const MOBILE_LIMIT = 4

export default {
  name: 'VehicleBulbsPreview',
  props: {
    products: { type: Array, required: true },
    othersCount: { type: Number, required: true },
    socket: { type: String, default: null },
    controls: { type: String, default: null },
  },
  computed: {
    title() {
      return this.socket
        ? this.$tc(
            'components.vehicleBulbsPreview.titleWithSocket',
            this.othersCount,
            { count: this.othersCount, socket: this.socket }
          )
        : this.$tc('components.vehicleBulbsPreview.title', this.othersCount, {
            count: this.othersCount,
          })
    },
    remaining() {
      return this.othersCount - this.products.length
    },
    mobileLimit() {
      return MOBILE_LIMIT
    },
    mobileRemaining() {
      return this.othersCount - Math.min(this.products.length, MOBILE_LIMIT)
    },
  },
  methods: {
    imageSrc(image) {
      return this.$cropUrl(image, 112, 112, image.extension, 86)
    },
  },
}
